import { Injectable } from '@angular/core';

import {
	DeleteAvatarResponse,
	SetAvatarResponse,
	SetAvatarUrlResponse,
} from '@reach/interfaces/avatar/avatar.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class AvatarApiService extends BaseApiService {
	protected commonPath = ['avatar'];

	public async changeAvatar(image: File): Promise<SetAvatarResponse> {
		const formData = new FormData();
		formData.append('image', image);

		return await this.http.post<SetAvatarResponse>(this.url(), formData);
	}

	public async delete(): Promise<DeleteAvatarResponse> {
		return await this.http.delete<DeleteAvatarResponse>(this.url());
	}

	public async addUrl(url: string): Promise<SetAvatarUrlResponse> {
		const body = { url };
		return await this.http.post<SetAvatarUrlResponse>(this.url('url'), body);
	}
}
